export type LumpsumPlanRecommendationStatusReason = {
  recommendationStatusReasonHeader?: string | null
  recommendationStatusReason?: string | null
}

export enum LumpsumImportantNoteRedirectionType {
  BOTTOMSHEET = 'BOTTOMSHEET',
  WEB_REDIRECTION = 'WEB_REDIRECTION',
  CTA_REDIRECTION = 'CTA_REDIRECTION'
}

export enum LumpsumFundDistributionStatus {
  INCOME = 'INCOME',
  ACCUMULATE = 'ACCUMULATE'
}

/** Shared fact-based / curated note shape used by allocation and rebalance. */
export interface LumpsumImportantNote {
  text?: string | null
  hyperlink?: {
    hyperlinkText?: string | null
    redirection?: {
      type?: LumpsumImportantNoteRedirectionType | null
      header?: string | null
      body?: string | null
      redirectionCta?: Record<any, any> | null
    } | null
  } | null
}

export interface LumpsumPlanRecommendationTaxInfo {
  gains: number | null
  investedAmount: number | null
  taxRate: number | null
  taxAmount: number | null
  exitLoad: number | null
}

export interface LumpsumPlanRecommendationTaxData {
  stcgTaxInfo: LumpsumPlanRecommendationTaxInfo | null
  ltcgTaxInfo: LumpsumPlanRecommendationTaxInfo | null
  exitLoad: number | null
  currentValue: number | null
  netTaxLiability: number | null
  taxCategory: string | null
}

export interface LumpsumPlanRecommendationUnderPerformance {
  xirrDiff: number | null
  xirrDiffDurationInMonths: number | null
  missedGains: number | null
}

export interface LumpsumPlanRecommendationHighExposure {
  highExposureCase: boolean | null
  targetPercentage: number | null
}

export interface LumpsumPlanRecommendationIdealAllocationPercentage {
  absolute: number | null
  upperLimit: number | null
  lowerLimit: number | null
}

export interface LumpsumPlanRecommendationOverExposure {
  overExposureCase: boolean | null
  reduceExposurePercentage: number | null
  sellFundIdealAllocationPercentage: LumpsumPlanRecommendationIdealAllocationPercentage | null
  buyFundIdealAllocationPercentage: LumpsumPlanRecommendationIdealAllocationPercentage | null
}

export interface LumpsumPlanRecommendationOverDiversification {
  overDiversificationCase: boolean | null
  targetFundCount: number | null
}

export enum LumpsumPlanTransferType {
  LUMPSUM = 'LUMPSUM',
  SWP = 'SWP'
}

export interface LumpsumPlanRecommendationCounterFund {
  isin: string | null
  fundName: string | null
  fundCategory: string | null
  fundNature: string | null
  purchaseMode: string | null
  distributionStatus: LumpsumFundDistributionStatus | null
  elss: boolean | null
  stcg: boolean | null
  mfLogoUrl: string | null
  powerRating: string | null
  powerRank: number | null
  actionType: string | null
  buyAmount: number | null
  sellAmount: number | null
  transferType: LumpsumPlanTransferType | null
  swpAmount: number | null
  swpDurationInMonths: number | null
  executed: boolean | null
  taxData: LumpsumPlanRecommendationTaxData | null
  underPerformance: LumpsumPlanRecommendationUnderPerformance | null
  highExposure: LumpsumPlanRecommendationHighExposure | null
}
